import {Scenario} from "@/models/scenario/scenario";
import {ProjectType} from "@/models/project.type";

export enum ArtifactType {
  None = 0,
  KPI,
  KPI_ERROR,
  KPIX,
  MOVEMENT,
  SCENARIO,
  SIM_CMD,
  SIM_LOG,
  SLICE_ERROR,
  SLICE_LOG
}

/** convert  type to string */
export function artifactType(type: ArtifactType) {

  switch (type) {
    case ArtifactType.None:        return 'none';
    case ArtifactType.KPI:         return 'kpi-download';
    case ArtifactType.KPIX:        return 'kpix-download';
    case ArtifactType.KPI_ERROR:   return 'kpi-error-download';
    case ArtifactType.MOVEMENT:    return 'movement-download';
    case ArtifactType.SCENARIO:    return 'scenario-download';
    case ArtifactType.SIM_CMD:     return 'sim-cmd-download';
    case ArtifactType.SIM_LOG:     return 'sim-log-download';
    case ArtifactType.SLICE_ERROR: return 'slice-error-download';
    case ArtifactType.SLICE_LOG:   return 'slice-log-download';
  }

  return 'none';
}

/** convert blob type string to blob type */
export function artifactString(text: string): ArtifactType {

  text = text.toLowerCase().trim();

  switch (text) {
    case 'none':                 return ArtifactType.None;
    case 'no-download':          return ArtifactType.None;
    case 'kpi-download':         return ArtifactType.KPI;
    case 'kpi-error-download':   return ArtifactType.KPI_ERROR;
    case 'kpix-download':        return ArtifactType.KPIX;
    case 'movement-download':    return ArtifactType.MOVEMENT;
    case 'scenario-download':    return ArtifactType.SCENARIO;
    case 'sim-cmd-download':     return ArtifactType.SIM_CMD;
    case 'sim-log-download':     return ArtifactType.SIM_LOG;
    case 'slice-error-download': return ArtifactType.SLICE_ERROR;
    case 'slice-log-download':   return ArtifactType.SLICE_LOG;
  }

  return ArtifactType.None;
}
